import Layout from "../../../components/Layout";
import Dashboard from "../Dashboard";

export default function Feedback() {
  return Layout(Dashboard, "Feedback Semanal");
}
